import { defineComponent, ref, computed } from 'vue'
import useBreakpoints from '@/composables/use-breakpoints'
import { whenever, useMounted, useCurrentElement, useEventListener, onClickOutside } from '@vueuse/core'
// @ts-ignore untyped library
import SlideToggle from 'vue-slide-up-down'
import { TransitionRoot } from '@headlessui/vue'
import SiteSearchRoot from './site-header/site-search-root.vue'
import SiteSearchInput from './site-header/site-search-input.vue'
import SiteNavRoot from './site-header/site-nav-root.vue'
import SiteNavList from './site-header/site-nav-list.vue'
import SiteNavItem from './site-header/site-nav-item.vue'
import SiteNavHeader from './site-header/site-nav-header.vue'
import SiteNavTrigger from './site-header/site-nav-trigger.vue'
import SiteNavContent from './site-header/site-nav-content.vue'
import SiteNavLink from './site-header/site-nav-link.vue'
import SiteNavSubLink from './site-header/site-nav-sublink.vue'

export default defineComponent({
    setup() {
        const breakpoints = useBreakpoints()
        const isLg = breakpoints.greaterOrEqual('lg')
        const el = /** @type {import('@vueuse/core').ComputedRefWithControl<HTMLElement>} */(useCurrentElement())
        const header = computed(() => el.value?.parentElement)
        const isMounted = useMounted()
        const searching = ref(false)
        const open = ref(false)
        const q = ref(/** @type {SiteSearchInput?} */(null))

        /** @param {MouseEvent} event */
        function onSearchClick(event) {
            if (searching.value || !isLg.value) return
            event.preventDefault()
            searching.value = true
        }

        // Autofocus input when open
        whenever(searching, () => q.value?.el?.focus(), { flush: 'post' })

        // Auto close when isLg
        whenever(isLg, () => open.value = false)

        // Close hamburger menu on outside events
        onClickOutside(computed(() => open.value ? header.value : null), () => open.value = false)
        useEventListener(computed(() => open.value ? window : null), 'scroll', () => open.value = false)
        useEventListener(computed(() => open.value ? document : null), 'keydown', /** @param {KeyboardEvent} event */(event) => {
            if (event.key === 'Escape') open.value = false
        })
        useEventListener(computed(() => open.value ? document : null), 'focus', (event) => {
            if (event.target && !header.value?.contains(/** @type {Node} */(event.target)))
                open.value = false
        })

        return {
            isLg,
            isMounted,
            searching,
            open,
            onSearchClick,
            q
        }
    },
    components: {
        SlideToggle,
        TransitionRoot,
        SiteSearchRoot,
        SiteSearchInput,
        SiteNavRoot,
        SiteNavList,
        SiteNavItem,
        SiteNavLink,
        SiteNavHeader,
        SiteNavTrigger,
        SiteNavContent,
        SiteNavSubLink,
    }
})